var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKabaddi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4576_1305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.56979 5.42773H17.4264V14.5686H2.56979V5.42773Z",
    fill: "#29A3EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.92664 5.85498H17.0695V14.1407H2.92664V5.85498Z",
    fill: "#3CDEF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.71545 5.14062V14.8552H10.2849V5.14062H9.71545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.14374 6.5708V7.14019H17.8566V6.5708H2.14374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.14374 12.856V13.4296H17.8566V12.856H2.14374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.42606 6.71387V13.2858H3.99973V6.71387H3.42606Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.85605 6.71387V13.2858H5.42973V6.71387H4.85605Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0006 6.71387V13.2858H16.5701V6.71387H16.0006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5706 6.71387V13.2858H15.1443V6.71387H14.5706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 4.85791V15.1425H18V14.8557V4.85791H2ZM2.57032 5.42709H17.4264V14.5688H2.57032V5.42709Z",
    fill: "#5A3392"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4576_1305"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKabaddi);
export default __webpack_public_path__ + "static/media/kabaddi.efa77ffb6f0f2a8893dc7ca81f29754e.svg";
export { ForwardRef as ReactComponent };